import { Button, message } from 'antd'
import { DocumentApi } from '../../../../api/Document'

import DocLinkToModal from '../../../../components/Common/Documents/Modal/DocLinkToModal'
import useModalData from '../../../../elements/Hooks/useModalData'
import React from 'react'

function DocLinkTo(props) {
  const { linkToType, file } = props

  console.log({ props })
  const { visible, modalType, submitting, checkForm, formRef, onShow, onCancel, setSubmitting, isNew } = useModalData()

  async function submit() {
    let newObject = await checkForm()
    newObject.file = file
    setSubmitting(true)
    try {
      const data = await DocumentApi.link(newObject)
      onCancel()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || e)
    }
    setSubmitting(false)
  }

  return (
    <div>
      <Button loading={submitting} onClick={onShow} style={{ float: 'left', marginBottom: 20 }}>
        Link To {linkToType}
      </Button>
      <DocLinkToModal
        {...{
          visible,
          modalType,
          submitting,
          checkForm,
          formRef,
          onShow,
          onCancel,
          setSubmitting,
          isNew,
          submit,
          linkToType,
          file,
        }}
      />
    </div>
  )
}

export default DocLinkTo
